import { net } from "../net/NetClient.js";
import { store } from "../store/GameStore.js";
import { button, el } from "./dom.js";

/** A non-blocking confirm bar shown when the player stands in the exit zone. */
export class ExitDialog {
  private readonly root: HTMLElement;

  constructor(parent: HTMLElement) {
    this.root = el("div", "panel side-panel hidden");
    this.root.style.bottom = "12px";
    this.root.style.top = "auto";
    this.root.style.right = "12px";
    this.root.style.width = "min(320px, 80vw)";
    this.root.appendChild(el("div", undefined, "Leave the office?"));

    const row = el("div", "tabs");
    row.style.marginTop = "8px";
    const leave = button("Leave (E)", "btn-primary");
    const stay = button("Stay (Esc)");
    leave.addEventListener("click", () => {
      net.send("exit");
      this.hide();
    });
    stay.addEventListener("click", () => this.hide());
    row.append(leave, stay);
    this.root.appendChild(row);

    parent.appendChild(this.root);
  }

  mount(): void {
    store.on("exitZone", ({ inside }) => (inside ? this.show() : this.hide()));
  }

  show(): void {
    this.root.classList.remove("hidden");
  }

  hide(): void {
    this.root.classList.add("hidden");
  }
}
